import type { RouteRecordRaw } from 'vue-router'
import { i18n } from '@/shared/i18n'

const { t } = i18n.global

export const CustomerTypePages = {
  list: 'ListCustomerType',
  add: 'AddCustomerType',
  edit: 'EditCustomerType',
}

const title = t('pages.listCustomerType')
const path = '/customer-types'
const breadcrumb = [{ title, path }]

const customerTypeFormComponent = () =>
  import('@/pages/mainPageWithRoute/customer-type/FormCustomerTypePage.vue')

const Add: RouteRecordRaw = {
  path: 'add',
  name: CustomerTypePages.add,
  component: customerTypeFormComponent,
  meta: { title: t('actions.add'), requiresAuth: true, breadcrumb },
}

const Edit: RouteRecordRaw = {
  path: ':id',
  name: CustomerTypePages.edit,
  component: customerTypeFormComponent,
  meta: { title: t('actions.edit'), requiresAuth: true, breadcrumb },
}

const List: RouteRecordRaw = {
  path: '',
  name: CustomerTypePages.list,
  component: () => import('@/pages/mainPageWithRoute/customer-type/ListCustomerTypePage.vue'),
  meta: { title, requiresAuth: true },
}

export const CustomerTypes: RouteRecordRaw = {
  path,
  name: t('pages.listCustomerType'),
  component: () => import('@/pages/mainPageWithRoute/MainPageWithRouterView.vue'),
  meta: { title, requiresAuth: true },
  children: [List, Add, Edit],
}
